<template lang="pug">
v-dialog(
  v-model="dialog"
  persistent
  max-width="400")
    v-card.pa-10.modal
      v-toolbar( class="close" flat style="height:24px")
        v-spacer
        v-btn(id="logout_modal_close_icon" icon @click="close")
          v-icon mdi-close
      v-card-text(style="text-align: center").pa-0
        div(class="pt-2")
          v-icon(size="60px") $logout-modal
        p.px-2.pt-6.pb-8.my-0.modal-text {{ $t('action.logout') }}
        v-row.mb-2.mt-0.mx-0(justify="center")
          v-col.py-0.px-0.mr-5
            v-btn(id="logout_modal_close_btn" depressed block class="rounded-lg pa-6" @click="close")
              | {{ $t('action.cancel') }}
          v-col.py-0.px-0
            v-btn(id="logout_modal_confirm" depressed block color="error" class="rounded-lg pa-6" :loading="loading"  @click="logout")
              | {{ $t('action.confirm') }}
</template>

<script>
import { UserService } from '@/services/user-service';
import { mapActions, mapGetters } from 'vuex';
import { LogoutRequests } from '@/services/http/logout-requests';

export default {

  name: 'AppLogout',

  data() {
    return {
      loading: false,
    };
  },

  computed: {
    ...mapGetters('Ui', ['getShowLogoutDialog']),
    dialog: {
      get() {
        return this.getShowLogoutDialog;
      },
      set(value) {
        this.$store.dispatch('Ui/setLogoutStatus', value);
      },
    },
  },

  methods: {
    ...mapActions('Ui', ['setLogoutStatus']),
    close() {
      this.dialog = false;
    },
    async logout() {

      this.loading = true;

      const [, error] = await LogoutRequests.logout();
      this.loading = false;
      if (error) {
        // TODO show error how? ask UX!
      } else {
        UserService.logout();
        this.close();
        this.$router.replace({ name: 'login' });
        this.$store.commit('user/resetUserData');
        this.$store.commit('Limits/resetLimits');
      }
    },
  },

};
</script>
<style lang="scss" scoped>

</style>
